<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Cashier information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex pa-2 xs11 :class="{ xs12: !hasPermissions(['users_store']) }">
              <v-autocomplete
                v-model="mainCashierInfo.user_id_fk"
                :items="staffsList"
                :label="`${$t('Staff')} *`"
                box
                hide-details
                :error="errors.has('Staff')"
                background-color="white"
                v-validate="'required'"
                data-vv-name="Staff"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
              <v-tooltip top>
                <v-btn label @click="$emit('add-staff')" slot="activator" icon fab small color="green">
                  <v-icon color="white" size="25">add</v-icon>
                </v-btn>
                <span>{{ $t('Add new staff') }}</span>
              </v-tooltip>
            </v-flex>

            <v-flex xs12 sm12 md12 class="py-1 px-2">
              <v-text-field
                v-model="mainCashierInfo.main_cashier_name"
                :label="`${$t('Cashier Name / Code')} *`"
                name="main_cashier_name"
                hide-details
                box
                background-color="white"
                :error="errors.has('main_cashier_name')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs6 sm6 class="pa-2">
              <v-menu offset-y full-width :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  v-model="mainCashierInfo.start_time"
                  :label="$t('Start Time')"
                  prepend-inner-icon="event"
                  box
                  hide-details
                  data-vv-name="start_time"
                  background-color="white"
                  autocomplete="off"
                />
                <v-time-picker v-model="time1" @input="formatStartTime(time1)" width="318" />
              </v-menu>
            </v-flex>
            <v-flex xs6 sm6 class="pa-2">
              <v-menu offset-y full-width :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  v-model="mainCashierInfo.end_time"
                  :label="$t('End Time')"
                  prepend-inner-icon="event"
                  box
                  hide-details
                  background-color="white"
                  data-vv-name="end_time"
                  autocomplete="off"
                />
                <v-time-picker v-model="time2" @input="formatEndTime(time2)" width="318" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      form: {},
      time1: null,
      time2: null
    }
  },

  computed: {
    ...mapGetters({
      mainCashierInfo: 'mainCashiers/getMainCashierInfo',
      staffsList: 'staff/getFullOutletStaffsList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
          this.time1 = this.mainCashierInfo.start_time
          this.time2 = this.mainCashierInfo.end_time
          this.formatStartTime(this.mainCashierInfo.start_time)
          this.formatEndTime(this.mainCashierInfo.end_time)
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateMainCashierInfo: 'mainCashiers/updateMainCashierInfo'
    }),

    formatStartTime(time) {
      if (time) {
        this.mainCashierInfo.start_time = helpers.formatTimeForDisplay(time)
      }
    },

    formatEndTime(time) {
      if (time) {
        this.mainCashierInfo.end_time = helpers.formatTimeForDisplay(time)
      }
    },

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('user_id_fk', this.mainCashierInfo.user_id_fk)
            formData.append('start_time', this.time1 || '')
            formData.append('end_time', this.time2 || '')

            let payload = {
              id: this.mainCashierInfo.main_cashier_id,
              formData
            }
            this.updateMainCashierInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
